import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import { Box, Typography } from "@mui/material";
import { LayoutWithSubmitButton } from "Components/Onboarding/shared/DocumentsUpload/LayoutWithSubmitButton";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  onNextStepRequested: () => void;
};

export const ExistingDocumentsInfo = ({ onNextStepRequested }: Props) => {
  const { t } = useResource();

  return (
    <LayoutWithSubmitButton onSubmitClick={onNextStepRequested}>
      <Box display="flex" alignItems="center" gap={4}>
        <HowToRegOutlinedIcon sx={{ fontSize: "3rem" }} />
        <Typography fontWeight="bold" fontSize={["0.875rem", "0.938rem"]}>
          {t(Resources.Onboarding.Steps.Documents.ExistingDocumentsInfo)}
        </Typography>
      </Box>
    </LayoutWithSubmitButton>
  );
};
